import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, unref, createBlock, createCommentVNode, Fragment, renderList } from "vue";
import { useColorMode } from "@scalar/use-hooks/useColorMode";
import { useMediaQuery } from "@vueuse/core";
import { useRoute } from "vue-router";
import _sfc_main$2 from "./HeaderItemGroup.vue.js";
import _sfc_main$4 from "./HeaderItemLink.vue.js";
import _sfc_main$1 from "./HeaderItemMeta.vue.js";
import HeaderItemSpacer from "./HeaderItemSpacer.vue.js";
import _sfc_main$3 from "./HeaderItemTab.vue.js";
import _sfc_main$5 from "./HeaderItemVersionSelect.vue.js";
import { DocumentClasses } from "../../themes/document-classes.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const route = useRoute();
    const { isDarkMode } = useColorMode();
    const logo = computed(() => {
      return isDarkMode.value ? props.project.logo.darkMode : props.project.logo.lightMode;
    });
    const isMobile = useMediaQuery("(max-width: 1000px)");
    const sortedHeaderLinks = computed(() => {
      const base = [...props.headerLinks];
      return isMobile.value ? base.sort((a) => a.type === "version-selector" ? -1 : 1).filter((a) => a.type !== "spacer") : base;
    });
    function navigateHandler(uid, type) {
      emit("navigate", type, uid);
      if (isMobile.value) emit("setSidebar", false);
    }
    function linkIsActive(item) {
      var _a;
      if ((_a = props.activeUids) == null ? void 0 : _a.includes(item.uid)) return true;
      if (item.uid === route.name || item.uid === props.activeGuide) return true;
      if (Object.values(route.params).includes(item.uid)) return true;
      if (item.type === "group") {
        return item.children.some((child) => linkIsActive(child));
      }
      return false;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", {
        class: normalizeClass(["header", unref(DocumentClasses).Header])
      }, [
        !unref(isMobile) ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          logo: logo.value,
          primaryVersionUid: _ctx.project.activeVersionId,
          projectName: _ctx.project.name
        }, null, 8, ["logo", "primaryVersionUid", "projectName"])) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(sortedHeaderLinks.value, (item) => {
          return openBlock(), createElementBlock(Fragment, {
            key: item.uid
          }, [
            item.type === "group" ? (openBlock(), createBlock(_sfc_main$2, {
              key: 0,
              group: item,
              isEditable: !!_ctx.isEditable,
              isMobile: unref(isMobile),
              linkIsActive,
              resolveInternalLinks: _ctx.resolveInternalLinks,
              onNavigate: navigateHandler
            }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : item.type === "guide" || item.type === "reference" ? (openBlock(), createBlock(_sfc_main$3, {
              key: 1,
              isEditable: !!_ctx.isEditable,
              isMobile: unref(isMobile),
              linkIsActive,
              resolveInternalLinks: _ctx.resolveInternalLinks,
              tab: item,
              onNavigate: navigateHandler
            }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab"])) : item.type === "link" ? (openBlock(), createBlock(_sfc_main$4, {
              key: 2,
              link: item
            }, null, 8, ["link"])) : item.type === "spacer" ? (openBlock(), createBlock(HeaderItemSpacer, { key: 3 })) : item.type === "version-selector" && Object.keys(_ctx.versions).length > 1 ? (openBlock(), createBlock(_sfc_main$5, {
              key: 4,
              activeVersion: _ctx.activeVersion,
              versions: _ctx.versions,
              onNavigate: navigateHandler
            }, null, 8, ["activeVersion", "versions"])) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DocumentHeader.vue.js.map
